import React from 'react';
import { motion } from 'framer-motion';
import { Target, Dumbbell, Apple, CloudRain, ShieldAlert, Calendar } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    icon: <Target className="w-8 h-8 text-white/90" data-id="element-17" />,
    emoji: '🎯',
    label: 'Bonus 1',
    title: 'Bonus 1 — NIVELÓMETRO DE CATEGORÍAS',
    desc: 'La matriz para armar tus equipos A, B y C con criterio técnico real. Tests graficados por categoría. Hoja de admisión rápida lista para imprimir.',
    cover: '#0284C7',
    spine: '#075985'
  }, {
    icon: <Dumbbell className="w-8 h-8 text-white/90" data-id="element-18" />,
    emoji: '💪',
    label: 'Bonus 2',
    title: 'Bonus 2 — FÍSICO EXPRESS',
    desc: '15 minutos de preparación física integrada a la clase. Más rendimiento. Menos lesiones. Sin sala de musculación. Solo el campo y un sistema probado.',
    cover: '#EA580C',
    spine: '#C2410C'
  }, {
    icon: <Apple className="w-8 h-8 text-white/90" data-id="element-19" />,
    emoji: '🍎',
    label: 'Bonus 3',
    title: 'Bonus 3 — NUTRICIÓN Y RENDIMIENTO',
    desc: 'Qué comer antes, durante y después de la práctica. El semáforo de hidratación. Protocolo de partido y guía lista para enviar por WhatsApp a los padres.',
    cover: '#0EA5E9',
    spine: '#0284C7'
  }, {
    icon: <CloudRain className="w-8 h-8 text-white/90" data-id="element-20" />,
    emoji: '🌧️',
    label: 'Bonus 4',
    title: 'Bonus 4 — PLAN DE LLUVIA',
    desc: '10 clases teóricas de alto valor para dar bajo techo cuando llueve. Nunca más cancelar y perder el ingreso. Nunca más improvisar en el vestuario.',
    cover: '#0EA5E9',
    spine: '#0369A1'
  }, {
    icon: <ShieldAlert className="w-8 h-8 text-white/90" data-id="element-21" />,
    emoji: '🚨',
    label: 'Bonus 5',
    title: 'Bonus 5 — KIT DE SUPERVIVENCIA',
    desc: '8 protocolos de emergencia para los días de caos. Alumno de mal humor, sin materiales, grupo mixto, 20 minutos de clase. Resuelto.',
    cover: '#F97316',
    spine: '#EA580C'
  }, {
    icon: <Calendar className="w-8 h-8 text-white/90" data-id="element-22" />,
    emoji: '📋',
    label: 'Bonus 6',
    title: 'Bonus 6 — PACK DE ORGANIZACIÓN SEMANAL',
    desc: 'Planillas de asistencia, cobro, inventario y gestión. Dominá tu semana en 15 minutos cada domingo. Listo para imprimir y usar.',
    cover: '#0EA5E9',
    spine: '#0284C7'
  }];
  return <section className="bg-[#0369A1] py-20 px-4" data-id="element-23">
      <div className="max-w-6xl mx-auto" data-id="element-24">
        <div className="text-center mb-16" data-id="element-25">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-6xl font-bold text-[#F97316] mb-6 uppercase tracking-wide" data-id="element-26">
            + 6 Regalos Estratégicos
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl md:text-2xl text-white mb-8" data-id="element-27">
            Incluidos sin costo extra · Valor real del pack
          </motion.p>
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="inline-block bg-[#F97316] text-white font-bold text-2xl px-8 py-4 rounded-xl shadow-[0_0_20px_rgba(249,115,22,0.4)] uppercase tracking-wider" data-id="element-28">
            🎁 GRATIS POR EL DÍA DE HOY
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-29">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-2xl p-8 flex flex-col items-center text-center shadow-lg" data-id="element-30">
              {/* Book-cover mockup */}
              <div className="mb-8 mt-2" data-id="element-31">
                <div className="relative w-44 h-60 rounded-r-lg rounded-l-sm shadow-[0_15px_30px_-8px_rgba(0,0,0,0.35)] flex flex-col p-5 text-left" style={{
              backgroundColor: bonus.cover
            }} data-id="element-32">
                  {/* Spine */}
                  <div className="absolute left-0 top-0 h-full w-3 rounded-l-sm" style={{
                backgroundColor: bonus.spine
              }} data-id="element-33" />
                  <div className="pl-2 flex flex-col h-full" data-id="element-34">
                    <div className="mb-auto" data-id="element-35">{bonus.icon}</div>
                    <span className="text-white text-2xl font-bold font-['Anton'] tracking-wide" data-id="element-36">
                      {bonus.label}
                    </span>
                    <div className="w-12 h-px bg-white/40 my-3" data-id="element-37" />
                    <span className="text-white/80 text-xs font-bold tracking-widest uppercase" data-id="element-38">
                      HOCKEY 360™
                    </span>
                  </div>
                </div>
              </div>

              {/* GRATIS pill */}
              <span className="inline-block bg-[#F97316]/15 text-[#EA580C] font-bold text-sm px-4 py-1.5 rounded-full uppercase tracking-wider mb-5" data-id="element-39">
                GRATIS
              </span>

              <h3 className="text-xl font-bold text-[#0284C7] mb-3 uppercase leading-snug" data-id="element-40">
                <span className="mr-1" data-id="element-41">{bonus.emoji}</span>
                {bonus.title}
              </h3>
              <p className="text-gray-500 font-medium leading-relaxed" data-id="element-42">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}